<template>
  <div>
    <div class="search" v-if="!showResult">
      <div class="searchFormBox">
        <div class="searchForm">
          <h2 class="ta-center pb-20">{{ examTitle }}</h2>
          <el-form
            ref="searchForm"
            :model="searchForm"
            label-width="120px"
            :rules="rules"
          >
            <template v-for="item in searchKeys">
              <el-form-item
                :key="item.key_id"
                :label="item.key_title"
                :prop="item.key_id.toString()"
              >
                <el-input
                  v-model="searchForm[item.key_id]"
                  :placeholder="'请输入' + item.key_title"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item label="验证码" prop="captcha">
              <el-input
                class="width-percent-60"
                v-model="searchForm.captcha"
                placeholder="请输入验证码"
              ></el-input>
              <img :src="imgSrc" @click="getCaptcha()" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('searchForm')"
                >查询</el-button
              >
              <el-button @click="reset">重填</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="SchoolReport" v-if="showResult">
      <template v-if="document.body.clientWidth > 425">
        <div style="overflow: auto">
          <span class="return cursor-pointer" @click="showResult = false">
            <b class="mr-2">←</b>
            <span>返回</span>
          </span>
        </div>
        <div class="examTitle">
          {{ examTitle }}
        </div>
        <!-- 表格 -->
        <el-table
          class="table"
          row-class-name="clickable cursor-default"
          :data="tableData"
          align="center"
        >
          <el-table-column
            v-for="(item, key) in tableHeader"
            :key="key"
            :prop="key.toString()"
            :label="item"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[key] || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div class="show-mobile-data">
          <ul>
            <li v-for="index in tableHeader.length" :key="index">
              <label>{{tableHeader[index-1]}}</label>
              <span>{{tableData[0][index-1]}}</span>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'search',
  components: {},
  data() {
    return {
      document: document,
      showResult: false,
      examTitle: '', // 考试名称
      searchKeys: {}, // 查询字段
      imgId: null,
      imgSrc: '', // 验证码
      searchForm: {
        captcha: '',
      }, // 表单查询数据
      rules: {
        captcha: [{ required: true, message: `请输入验证码`, trigger: 'blur' }],
      },
      count: null,
      tableHeader: [], // 表格表头
      tableData: [], // 表格数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    /**
     * 获取验证码
     */
    getCaptcha() {
      this.$api.getCaptcha().then((res) => {
        this.imgId = res.id
        this.imgSrc = res.base_64
      })
    },

    /**
     * 获取查询条件
     */
    getSearchKey() {
      this.$api.getSearchKey(parseInt(this.$route.params.id)).then((res) => {
        document.title = res.exam_result_title
        this.examTitle = res.exam_result_title
        this.searchKeys = res.search_fields
        res.search_fields.map((i) => {
          this.$set(this.searchForm, i.key_id, '')
          this.$set(this.rules, i.key_id, [
            {
              required: true,
              message: `请输入${i.key_title}`,
              trigger: 'blur',
            },
          ])
        })
      })
    },
    /**
     * 查询
     */
    submitForm: _.debounce(
      function (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            // eslint-disable-next-line camelcase
            const field_values = JSON.parse(JSON.stringify(this.searchForm))
            delete field_values.captcha
            let param = {
              exam_result_id: parseInt(this.$route.params.id),
              captcha_id: this.imgId,
              captcha_answer: this.searchForm.captcha,
              field_values: field_values,
            }
            this.$api.getSearchDetail(param).then((res) => {
              this.getCaptcha()
              this.searchForm.captcha = ''
              if (res.count > 0) {
                this.showResult = true
                this.count = res.count
                this.tableHeader = res.titles
                this.tableData = res.list
                setTimeout(()=>{
                  console.log(this.tableHeader)
                  console.log(this.tableData)
                },1000)
              } else {
                this.$message({
                  message: '查无数据,请检查输入是否有误！',
                  type: 'warning',
                })
              }
            })
          }
        })
      },
      300,
      {
        leading: true,
        trailing: false,
      }
    ),
    /**
     * 重填
     */
    reset() {
      Object.keys(this.searchForm).forEach((key) => {
        this.searchForm[key] = ''
      })
    },
  },
  created() {},
  mounted() {
    this.getSearchKey()
    this.getCaptcha()
  },
}
</script>

<style scoped lang="scss">
@media all and (max-width: 425px) {
  body {
    min-width: unset !important;
  }
  .search {
    .searchFormBox {
      // transform: scale(1.5);
      padding: 20px !important;
      box-sizing: border-box;
      width: 88% !important;
      .searchForm {
        width: 100%;
        padding: 0 !important;
        h2 {
          font-size: 16px;
        }
      }
    }
    img {
      width: 50px !important;
    }
  }
  .SchoolReport {
    padding-top: 1px;
    box-sizing: border-box;
    .examTitle {
      display: none !important;
    }
    .return {
      display: none;
    }
    .table {
      width: 88% !important;
      margin-top: 80px !important;
    }
  }
}

.search {
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/bgBlueBook.jpg');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .searchFormBox {
    width: 580px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(53, 72, 137, 0.5);
    margin: 0 auto;
    padding: 80px 0 80px 130px;
    .searchForm {
      padding-right: 170px;
      max-height: 560px;
      overflow-y: auto;
    }
    .searchForm::-webkit-scrollbar {
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    .searchForm::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #8fdefd;
    }
    .searchForm::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
  }
  img {
    height: 37px;
    width: 115px;
    vertical-align: bottom;
    margin-left: 10px;
  }
}
.SchoolReport {
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/bgBlueCloud.jpg');
  background-size: cover;
  text-align: center;
  .return {
    margin: 62px 0 58px 52px;
    float: left;
    width: 110px;
    height: 52px;
    line-height: 52px;
    background: #4dc3ff;
    border-radius: 26px;
    // display: inline-block;
    color: #fff;
    font-size: 14px;
  }
  .examTitle {
    padding: 15px 30px;
    background: #fff;
    border-radius: 26px;
    font-size: 18px;
    color: #188eba;
    font-weight: 600;
    display: inline-block;
  }
  .table {
    margin: 44px auto 0;
    width: 80%;
    max-height: 60%;
    overflow: auto;
  }
  /* 移动端才会有的dom */
  .show-mobile-data {
    max-width: 80%;
    max-height: 90%;
    border-radius: 4px;
    margin: 5% auto 0;
    position: relative;
    overflow: auto;
    ul,
    ol {
      padding: 0;
      margin: 0;
      list-style: none;
      li {
        white-space: nowrap;
        min-height: 48px;
        box-sizing: border-box;
        width: 100%;
        border-bottom: 1px solid #f2f2f2;
        background-color: #fff;
        > * {
          min-height: inherit;
          box-sizing: border-box;
          word-break: break-all;
          word-wrap: break-word;
          display: inline-block;
          white-space: break-spaces;
          padding: 10px;
          vertical-align: top;
        }
        > label {
          font-weight: bolder;
          color: #333;
          width: 30%;
        }
        > span {
          color: #666;
          width: 70%;
        }
      }
    }
  }
}
</style>
